export const regexHtmlTag = () => {
    return "<[^<>]+>";
}

export const getTagInHtmlPage = (htmlPage) => {
    let foundValues = [];
    if (htmlPage) {
        const regex = new RegExp(regexHtmlTag(), "gi");
        foundValues = [...htmlPage.matchAll(regex)];
    }
    return foundValues;
}

export const isInHtmlTagAttributes = (index, htmlTagInPage) => {
    let isInTagAttributes = false;
    if (htmlTagInPage) {
        for (const tagItem of htmlTagInPage) {
            if (index >= tagItem.index && index < tagItem.index + tagItem[0].length) {
                isInTagAttributes = true;
                break;
            }
            if (index < tagItem.index) {
                break;
            }
        };
    }
    return isInTagAttributes;
}